import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../urunDiv.css';
import turkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import doubleTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import dibekTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import doubleDibekTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import cilekliTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import doubleCilekliTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import damlaSakizliTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import doubleDamlaSakizliTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';
import kumdaTurkKahvesi from '../../../../assets/menu/icecekler/turk-kahveleri.png';

const TurkKahveleri = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const turkKahveKategorileri = {
    'Türk Kahveleri': [
      {
        id: 1,
        name: 'Türk Kahvesi',
        price: '₺139,90',
        image: turkKahvesi
      },
      {
        id: 2,
        name: 'Double Türk Kahvesi',
        price: '₺189,90',
        image: doubleTurkKahvesi
      },
      {
        id: 3,
        name: 'Dibek Türk Kahvesi',
        price: '₺139,90',
        image: dibekTurkKahvesi
      },
      {
        id: 4,
        name: 'Double Dibek Türk Kahvesi',
        price: '₺189,90',
        image: doubleDibekTurkKahvesi
      },
      {
        id: 5,
        name: 'Çilekli Türk Kahvesi',
        price: '₺139,90',
        image: cilekliTurkKahvesi
      },
      {
        id: 6,
        name: 'Double Çilekli Türk Kahvesi',
        price: '₺189,90',
        image: doubleCilekliTurkKahvesi
      },
      {
        id: 7,
        name: 'Damla Sakızlı Türk Kahvesi',
        price: '₺139,90',
        image: damlaSakizliTurkKahvesi
      },
      {
        id: 8,
        name: 'Double Damla Sakızlı Türk Kahvesi',
        price: '₺189,90',
        image: doubleDamlaSakizliTurkKahvesi
      },
      {
        id: 9,
        name: 'Kumda Türk Kahvesi',
        price: '₺169,90',
        image: kumdaTurkKahvesi
      }
    ]
  };

  const handleKahveClick = (kahve) => {
    if (kahve.name === 'Türk Kahvesi') {
      navigate('/turk-kahveleri/turk-kahvesi');
    } else if (kahve.name === 'Double Türk Kahvesi') {
      navigate('/turk-kahveleri/double-turk-kahvesi');
    } else if (kahve.name === 'Dibek Türk Kahvesi') {
      navigate('/turk-kahveleri/dibek-turk-kahvesi');
    } else if (kahve.name === 'Double Dibek Türk Kahvesi') {
      navigate('/turk-kahveleri/double-dibek-turk-kahvesi');
    } else if (kahve.name === 'Çilekli Türk Kahvesi') {
      navigate('/turk-kahveleri/cilekli-turk-kahvesi');
    } else if (kahve.name === 'Double Çilekli Türk Kahvesi') {
      navigate('/turk-kahveleri/double-cilekli-turk-kahvesi');
    } else if (kahve.name === 'Damla Sakızlı Türk Kahvesi') {
      navigate('/turk-kahveleri/damla-sakizli-turk-kahvesi');
    } else if (kahve.name === 'Double Damla Sakızlı Türk Kahvesi') {
      navigate('/turk-kahveleri/double-damla-sakizli-turk-kahvesi');
    } else if (kahve.name === 'Kumda Türk Kahvesi') {
      navigate('/turk-kahveleri/kumda-turk-kahvesi');
    }
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Türk Kahveleri</h2>
        </div>
        
        <div>
          <hr style={{color: '#D8D8D8'}} />
          <div className="urun-grid">
            {turkKahveKategorileri['Türk Kahveleri'].map((kahve) => (
              <div 
                key={kahve.id} 
                className="urun-kart"
                onClick={() => handleKahveClick(kahve)}
                style={{ cursor: 'pointer' }}
              >
                <div className="urun-bilgi">
                  <h3 className="urun-ad">{kahve.name}</h3>
                  <div className="urun-fiyat">{kahve.price}</div>
                </div>
                <div className="urun-resim">
                  <img src={kahve.image} alt={kahve.name} style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                    borderRadius: '100px',
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Türk Kahveleri</h2>
        </div>
        
        <div style={{marginBottom: '80px'}}>
          <hr style={{color: '#D8D8D8'}} />
          <div className="urun-grid-computer">
            {turkKahveKategorileri['Türk Kahveleri'].map((kahve) => (
              <div 
                key={kahve.id} 
                className="urun-kart-computer"
                onClick={() => handleKahveClick(kahve)}
                style={{ cursor: 'pointer' }}
              >
                <div className="urun-bilgi">
                  <h3 className="urun-ad-computer">{kahve.name}</h3>
                  <div className="urun-fiyat-computer">{kahve.price}</div>
                </div>
                <div className="urun-resim">
                  <img src={kahve.image} alt={kahve.name} style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '100px',
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default TurkKahveleri;
